import { AccessManager } from "@/components/AccessManager";

export default function Accesses() {
  return (
    <div className="space-y-6" data-testid="accesses-page">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Accesos</h1>
        <p className="text-muted-foreground mt-1">Tus plataformas y credenciales, protegidas por clave</p>
      </div>
      <AccessManager scope="own" />
    </div>
  );
}
